import { render, staticRenderFns } from "./LdUpgradeProductModal.vue?vue&type=template&id=1b8dfb9d"
import script from "./LdUpgradeProductModal.vue?vue&type=script&lang=js"
export * from "./LdUpgradeProductModal.vue?vue&type=script&lang=js"
import style0 from "./LdUpgradeProductModal.vue?vue&type=style&index=0&id=1b8dfb9d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports